import { type DateRangeValueType } from '@wf/components';

import { type SortDirection } from '../constants';

export type RestrictionValueType = string | number | SelectOption | Date | DateRangeValueType | boolean;

export interface IRestriction<T = RestrictionValueType> {
  field: string;
  value?: T;
  values?: T[];
  valueTo?: T;
  operator?: string;
  label?: string;
}

export interface ISortConfig<T> {
  field: keyof T;
  mode: SortDirection;
}

export interface IPagination {
  size: number;
  currentPage: number;
}

export interface IStateData<T> {
  data: T[];
  isLoading: boolean;
  totalCount: number;
  pagination: IPagination;
  sortConfig: ISortConfig<T>;
}

export interface IErrorResponse {
  code: string;
  message: string;
  messageArguments: string[];
  messageCode: string;
  field: string;
}

export interface IUserAttributes {
  DEC?: string;
  DEP?: string;
  LVL?: string | number;
  MIN?: string;
  TIN?: string;
}

export enum LicenseTypeNature {
  LPCO = 'LPCO',
  EPHYTO = 'EPHYTO',
  // EXEMPTION = 'EXEMPTION',
}

export enum Country {
  BANGLADESH = 'bangladesh',
  NIGER = 'niger',
}
